/**
 * Calculates the best fit dimensions for an element within a container
 * while maintaining the specified aspect ratio (using width to height ratio)
 *
 * @param containerWidth - Available width of the container
 * @param containerHeight - Available height of the container
 * @param widthToHeightRatio - Width to height ratio (e.g., 1 for 1:1, 1.5 for 3:2)
 * @returns Object containing fitted width and height
 */
export const calculateBestFit = (containerWidth: number, containerHeight: number, widthToHeightRatio: number) => {
  // Calculate dimensions if we fit by width (width = containerWidth)
  const fitByWidth = {
    width: containerWidth,
    height: containerWidth / widthToHeightRatio,
  };

  // Calculate dimensions if we fit by height (height = containerHeight)
  const fitByHeight = {
    width: containerHeight * widthToHeightRatio,
    height: containerHeight,
  };

  // Choose the fit that doesn't exceed container bounds
  if (fitByWidth.height <= containerHeight) {
    // Fitting by width works - element height fits within container
    return fitByWidth;
  } else {
    // Must fit by height - width constraint is more limiting
    return fitByHeight;
  }
};
